import { categoriesSelectors } from 'app-components/flux/categories';
import { chartOfAccountsSelectors, chartOfAccountsUtils } from 'app-components/flux/chart-of-accounts';
import { scheduledTransactionsUtils } from 'app-components/flux/scheduled-transactions';
import type { ScheduledTransactionEditSeriesType } from 'app-components/flux/scheduled-transactions/scheduledTransactionEditForm';
import type { TransactionProps } from 'app-components/flux/transactions/transactionsTypes';
import type { RootState } from 'store';

export type { ScheduledTransactionEditSeriesType as SeriesType } from 'app-components/flux/scheduled-transactions/scheduledTransactionEditForm';

/**
 * Derives the series' Type (as shown in the Basic Details Type select, and
 * used to gate the Bill Connect tab) from the underlying transaction/category
 * rather than trusting the stored isBill/isSubscription/isTransfer/isIncome
 * flags alone — those can lag behind an unconfirmed category or account
 * change (e.g. picking a transfer/credit-card category doesn't flip
 * `isTransfer` until the change is applied), same derivation basicTab has
 * always used for its Type select.
 */
export function deriveScheduledTransactionSeriesType(
  state: RootState,
  transaction: TransactionProps,
): ScheduledTransactionEditSeriesType {
  const incomeCOAIds = categoriesSelectors.getIncomeCOAIds(state);
  const seriesPrimaryCoa = scheduledTransactionsUtils.getSeriesPrimaryCoa(transaction);
  const isCredit = Boolean(
    transaction && chartOfAccountsSelectors.isCreditBill(state, transaction.accountId, transaction.coa),
  );
  const isIncome = scheduledTransactionsUtils.isIncomeSeriesFromTxn(transaction, incomeCOAIds);
  const isTransfer = Boolean(seriesPrimaryCoa && chartOfAccountsUtils.isTransferCOA(seriesPrimaryCoa)) || isCredit;

  if (isTransfer) {
    return 'TRANSFER';
  }
  if (isIncome) {
    return 'INCOME';
  }
  return transaction.isSubscription ? 'SUBSCRIPTION' : 'BILL';
}
